import { FiltersTypes } from "@common/types/filters/general";
import {
    ActiveFilter,
    ActiveFilterToFilterTabsMap,
    activeFiltersOrder,
    FilterTabs,
    isActive,
} from "@components/pageHeader/filters/lib";

export function getLockedActiveFilters({
    lockableTabs,
    originalFilters,
}: {
    lockableTabs: ReadonlySet<FilterTabs>;
    originalFilters: FiltersTypes | undefined;
}): ActiveFilter[] {
    if (!originalFilters) {
        return [];
    }
    return activeFiltersOrder.filter(
        (filterId) =>
            lockableTabs.has(ActiveFilterToFilterTabsMap[filterId]) &&
            isActive[filterId](originalFilters),
    );
}
